<script>
import CommonConstants from '../../common/Constants';
import config from '../../common/genericPanelConf';
import Utils from '../../common/Utils';
import { required } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import Service from '@/services/fiscal-notification';
import CommonService from '@/services/common';

import ResponsiveButton from '../../components/generic/ResponsiveButton.vue'
import GenericDataTable from '../../components/generic/GenericDataTable.vue';
import GenericCustomAutocompleteV2 from '../../components/generic/GenericCustomAutocompleteV2.vue';
import InputText from 'primevue/inputtext';

export default{
    setup: () => ({ v$: useVuelidate() }),
  components: {
    ResponsiveButton,
    GenericDataTable,
    GenericCustomAutocompleteV2
  },
  data(){
    return {
        filters: {
            notificationDate: Utils.formatDatePlusMonths(new Date(), 0),
            notificationDateTo: Utils.formatDatePlusDays(new Date(), 1),
            idRegistryPlant: null
        },

        calculatorFilters: {
          idRegistryProduct: null,
          nc: null,
          idRegistryFiscalPosition: null,
          idRegistryFiscalUse: null,
          idRegistryFiscalDestination: null,
          idRegistryOperationType: null,
          fiscalDate: Utils.formatDatePlusMonths(new Date(), 0),
          movedQuantity: 0,
          movedVolume: 0,
          idEneryProductDetail: null
        },

        exciseCalculatorResult: {
          exciseRate: 0,
          exciseDelta: 0, 
          exciseDuty: 0,
          exciseDutySuspended: 0,
          exciseDue: 0, 
          localExciseDue: 0, 
          taxableQuantity: 0
        },

        exportCalculatorFilters: {
          idRegistryProduct: null,
          nc: null,
          idRegistryFiscalPosition: null,
          idRegistryFiscalUse: null,
          idRegistryFiscalDestination: null,
          idRegistryOperationType: null,
          fiscalDate: Utils.formatDatePlusMonths(new Date(), 0),
          fiscalMovedWeight: 0,
          fiscalMovedVolume: 0,
          idEneryProductDetail: null
        },

        transportType: null,
        showCalculatorDialog: false,
        showExportCalculatorDialog: false
    }
  },
  validations(){
    return {
        
    }
  },
  computed: {
    constants(){
        return CommonConstants;
    },
    utils(){
      return Utils;
    },
    uiPermissions(){
      return this.$store.getters['security/uiPermissions'];
    }
  },
  watch:{
    'calculatorFilters.idRegistryOperationType'(){
      this.setTransportType();
    },

    'exportCalculatorFilters.idRegistryOperationType'(){
      this.setTransportType2();
    }
  },
  created(){
    this.configuration = config.getConfiguration('ExciseFiscalRegister');
  },
  mounted(){
    this.$store.dispatch('security/setNavbarTitle', 'ExciseFiscalRegister.page_title');
    let cacheFilters = null;
        let cacheData = this.$store.getters['cacheDataStore/getGridCache']('ExciseFiscalRegisterGrid');
        if(cacheData){
            cacheFilters = {};
            for(let i = 0; i < cacheData.length; i++){
                let element = cacheData[i];
                cacheFilters[element.property] = element;
                // let k = element.property.charAt(0).toLowerCase() + element.property.slice(1);
                this.filters[element.propName] = element.value;
            }
            if(cacheFilters){
                this.loadExciseFiscalRegister();
            }
        }       
  },
  methods: {
    loadExciseFiscalRegister(){
        this.submitted = true;
        let filters = [];
        
        filters.push({
            operator: '>=',
            value: Utils.formatDateForAPIWithTime(this.filters.notificationDate),
            property: 'NotificationDate',
        });

        filters.push({
            operator: '<',
            value: Utils.formatDateForAPIWithTime(this.filters.notificationDateTo.setSeconds(this.filters.notificationDateTo.getSeconds() - 1)),
            property: 'NotificationDate',
        });

        let cacheData = {
          name: 'ExciseFiscalRegisterGrid',
          filters: filters
        };

        this.$store.dispatch("cacheDataStore/setGridCache", cacheData);
        this.$refs.exciseFiscalRegister.setGlobalFilters(filters);
        this.$refs.exciseFiscalRegister.filterFromView(filters);
        this.submitted = false;
    },
    onRowEdit(data){
      this.$store.dispatch("generic/setLoading", true);
      Service.updateExciseFiscalRegister(data, (response) => {
          this.$store.dispatch("generic/setLoading", false);
          if (response.success) {
              this.loadExciseFiscalRegister();
              this.$toast.add({ severity: 'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000 });
          } else {
              this.$toast.add({ detail: response.message && response.message != '' ? response.message : this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
          }
      })
    },
    openCalculatorDialog(){
      this.showCalculatorDialog = true;
    },

    ExciseCalculator(){

      let body = {
        nc: this.calculatorFilters.nc,
        idEneryProductDetail: this.calculatorFilters.idEneryProductDetail,
        idRegistryFiscalPosition: this.calculatorFilters.idRegistryFiscalPosition,
        idRegistryFiscalUse: this.calculatorFilters.idRegistryFiscalUse,
        idRegistryFiscalDestination: this.calculatorFilters.idRegistryFiscalDestination,
        fiscalDate: this.calculatorFilters.fiscalDate,
        movedQuantity: this.calculatorFilters.movedQuantity,
        movedVolume: this.calculatorFilters.movedVolume
      };

      CommonService.loadGenericItem('masterdata/energy-product-detail', this.calculatorFilters.idEneryProductDetail, response => {
        if(response.success && response.data != null){
          CommonService.loadGenericItem('masterdata/energy-product', response.data.idRegistryEnergyProduct, res => {
            if(res.success && res.data != null){
              body.nc = res.data.nc;
              this.$store.dispatch("generic/setLoading", true);
              Service.calculatorExciseFiscalRegister(body, (response) => {
                  this.$store.dispatch("generic/setLoading", false);
                  if (response.success && response.data != null) {
                    let data = response.data;

                    this.exciseCalculatorResult.exciseRate = data.exciseRate;
                    this.exciseCalculatorResult.exciseDelta = data.exciseDelta;
                    this.exciseCalculatorResult.exciseDuty = data.exciseDuty;
                    this.exciseCalculatorResult.exciseDutySuspended = data.exciseDutySuspended;
                    this.exciseCalculatorResult.exciseDue = data.exciseDue; 
                    this.exciseCalculatorResult.localExciseDue = data.localExciseDue; 
                    this.exciseCalculatorResult.taxableQuantity = data.taxableQuantity;

                    if(data.documentType != null){
                      this.exciseCalculatorResult.documentType = data.documentType.description;
                      this.exciseCalculatorResult.documentTypeLanguage = data.documentType.languageCode;
                    }
                    } else {
                      this.$toast.add({ detail: response.message && response.message != '' ? response.message : this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
                  }
              })
            }
          });
        }
      })     
    },
    ResetCalculator(){

      this.calculatorFilters = {
          idRegistryProduct: null,
          nc: null,
          idRegistryFiscalPosition: null,
          idRegistryFiscalUse: null,
          idRegistryFiscalDestination: null,
          idRegistryOperationType: null,
          fiscalDate: Utils.formatDatePlusMonths(new Date(), 0),
          movedQuantity: 0,
          movedVolume: 0,
        };

      this.exciseCalculatorResult = {
          idRegistryProduct: null,
          nc: null,
          idRegistryFiscalPosition: null,
          idRegistryFiscalUse: null,
          idRegistryFiscalDestination: null,
          fiscalDate: null,
          movedQuantity: 0,
          movedVolume: 0,
          exciseRate: 0,
          exciseDelta: 0, 
          exciseDuty: 0,
          exciseDutySuspended: 0,
          exciseDue: 0, 
          localExciseDue: 0, 
          taxableQuantity: 0
        };
    },
    setTransportType(){
      CommonService.loadGenericItem('masterdata/operation-type', this.calculatorFilters.idRegistryOperationType, response => {
        if(response.success && response.data != null){
            let idTransportType = response.data.idTransportType;             
            CommonService.loadGenericItem('masterdata/transport-type', idTransportType, responseTransport => {
              if(responseTransport.success && responseTransport.data != null){                
                  this.transportType = responseTransport.data.code;
              }
            });
          }
      });
    },
    setTransportType2(){
      CommonService.loadGenericItem('masterdata/operation-type', this.exportCalculatorFilters.idRegistryOperationType, response => {
        if(response.success && response.data != null){
            let idTransportType = response.data.idTransportType;             
            CommonService.loadGenericItem('masterdata/transport-type', idTransportType, responseTransport => {
              if(responseTransport.success && responseTransport.data != null){                
                  this.transportType = responseTransport.data.code;
              }
            });
          }
      });
    },
    onExportToCalculator(data){
      this.showExportCalculatorDialog = true;

      if(data.idFiscalNotificationHeader != null){
        Service.getFiscalNotificationHeader(data.idFiscalNotificationHeader, response => {
          if (response.success && response.data != null) {
            this.exportCalculatorFilters.idEneryProductDetail = response.data.idEnergyProductDetail;
          } else {
              caller.$toast.add({ detail: response.message && response.message != '' ? response.message : caller.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
          }
        })
      }   

      this.exportCalculatorFilters = {
        idRegistryProduct: data.idRegistryProduct,
        nc: data.nc,
        idRegistryFiscalPosition: data.idRegistryFiscalPosition,
        idRegistryFiscalUse: data.idRegistryFiscalUse,
        idRegistryFiscalDestination: data.idRegistryFiscalDestination,
        idRegistryOperationType: data.idRegistryOperationType,
        notificationDate: Utils.dateToCurrentTimeZone(data.notificationDate),
        notificationCode: data.notificationCode,
        fiscalMovedWeight: data.fiscalMovedWeight,
        fiscalMovedVolume: data.fiscalMovedVolume,
        idRegistryPlant: data.idRegistryPlant,
        idFiscalNotificationHeader: data.idFiscalNotificationHeader,
        idRegistryEquipment: data.idRegistryEquipment,
        id: data.id,
        productCode: data.productCode,
        productDescription: data.productDescription,
        productFamily: data.productFamily,
        fiscalDestination: data.fiscalDestination,
        fiscalDocumentNumber: data.fiscalDocumentNumber,
        fiscalPosition: data.fiscalPosition,
        fiscalUse: data.fiscalUse,
        exciseRate: data.exciseRate,
        exciseDelta: data.exciseDelta, 
        exciseDuty: data.exciseDuty,
        exciseDutySuspended: data.exciseDutySuspended,
        exciseDue: data.exciseDue, 
        localExciseDue: data.localExciseDue, 
        taxableQuantity: data.taxableQuantity,
        denaturantQuantity: data.denaturantQuantity,
        denaturantVolume: data.denaturantVolume,
        density: data.density,
        fiscalStockVolume: data.fiscalStockVolume,
        fiscalStockWeight: data.fiscalStockWeight,
        infoilCvtOperationKey: data.infoilCvtOperationKey,
        isGas: data.isGas,
        placeOfDeliveryName: data.placeOfDeliveryName,
        portOrLocation: data.portOrLocation
      };

      console.log(this.exportCalculatorFilters);
    },
    ExciseCalculatorItem(){
      let body = {
        nc: this.exportCalculatorFilters.nc,
        idEneryProductDetail: this.exportCalculatorFilters.idEneryProductDetail,
        idRegistryFiscalPosition: this.exportCalculatorFilters.idRegistryFiscalPosition,
        idRegistryFiscalUse: this.exportCalculatorFilters.idRegistryFiscalUse,
        idRegistryFiscalDestination: this.exportCalculatorFilters.idRegistryFiscalDestination,
        fiscalDate: this.exportCalculatorFilters.notificationDate,
        movedQuantity: this.exportCalculatorFilters.fiscalMovedWeight,
        movedVolume: this.exportCalculatorFilters.fiscalMovedVolume
      };

      this.$store.dispatch("generic/setLoading", true);
      Service.calculatorExciseFiscalRegister(body, (response) => {
          this.$store.dispatch("generic/setLoading", false);
          if (response.success && response.data != null) {

            let data = response.data;

            this.exportCalculatorFilters.exciseRate = data.exciseRate;
            this.exportCalculatorFilters.exciseDelta = data.exciseDelta;
            this.exportCalculatorFilters.exciseDuty = data.exciseDuty;
            this.exportCalculatorFilters.exciseDutySuspended = data.exciseDutySuspended;
            this.exportCalculatorFilters.exciseDue = data.exciseDue; 
            this.exportCalculatorFilters.localExciseDue = data.localExciseDue; 
            this.exportCalculatorFilters.taxableQuantity = data.taxableQuantity;

            if(data.documentType != null){
              this.exportCalculatorFilters.documentType = data.documentType.description;
              this.exportCalculatorFilters.documentTypeLanguage = data.documentType.languageCode;
            }
          } else {
              this.$toast.add({ detail: response.message && response.message != '' ? response.message : this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
          }
      })
    },
    onCalculatorSave(){     
      this.$confirm.require({
        message: this.$t('messages.generic_confirm_message'),
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: this.$t('yes'),
        rejectLabel: this.$t('no'),
        accept: () => {                  
          this.$store.dispatch("generic/setLoading", true);
          Service.updateExciseFiscalRegister(this.exportCalculatorFilters, (response) => {
            this.$store.dispatch("generic/setLoading", false);
            if (response.success) {
                this.loadExciseFiscalRegister();
                this.showExportCalculatorDialog = false;
                this.$toast.add({ severity: 'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000 });
            } else {
                this.$toast.add({ detail: response.message && response.message != '' ? response.message : this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
            }
          })
        },
        reject: () => {
          this.$confirm.close();
        }
      });
    }
  }
}

</script>

<template>
    <main>
      <Dialog v-model:visible="showCalculatorDialog" modal :style="{width: '80vw'}">
        <div class="grid">
          <Card class="col-4">
            <template #content>
              <div class="grid formgrid">
                <div class="col-12 lg:col-6 field">
                  <label for="notificationDate">{{ $t('ExciseFiscalRegister.notificationDate') }}</label>
                  <Calendar
                    class="p-inputtext-sm w-full"
                    placeholder="__/__/____"
                    v-model="this.calculatorFilters.fiscalDate"
                    name="fiscalDate" dateFormat="dd/mm/yy" :showTime="false"
                    :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
                </div>

                <!--<div class="col-12 lg:col-6 field">
                  <label for="notificationCode">{{ $t('ExciseFiscalRegister.notificationCode') }}</label>
                  <InputText class="w-full" v-model="this.calculatorFilters.notificationCode"/>
                </div>-->

                <div class="col-12 lg:col-6 field">
                  <label for="idRegistryOperationType">{{ $t('ExciseFiscalRegister.operationTypeDescription') }}</label>
                  <GenericCustomAutocompleteV2
                    class="w-full"
                    :name="idRegistryOperationType"
                    v-model="this.calculatorFilters.idRegistryOperationType" 
                    :api="'masterdata/operation-type-combo'"
                    :format="{ label: 'label', value: 'value' }"  />
                </div>

                <div class="col-12 lg:col-6 field">
                  <label for="idRegistryProduct">{{ $t('ExciseFiscalRegister.idRegistryProduct') }}</label>
                  <GenericCustomAutocompleteV2
                    class="w-full"
                    :name="idRegistryProduct"
                    v-model="this.calculatorFilters.idRegistryProduct" 
                    :api="'masterdata/product-combo'"
                    :format="{ label: 'label', value: 'value' }"  />
                </div>
                
                <div class="col-12 lg:col-6 field">
                  <label for="idEneryProductDetail">{{ $t('ExciseFiscalRegister.nc') }}</label>
                  <!--<InputText class="w-full" v-model="this.calculatorFilters.nc" />-->
                  <GenericCustomAutocompleteV2
                    class="w-full"
                    :name="idEneryProductDetail"
                    v-model="this.calculatorFilters.idEneryProductDetail" 
                    :api="'masterdata/energy-product-detail-combonc?idProduct=' + this.calculatorFilters.idRegistryProduct + '&transportType=' + this.transportType + '&getOnlyValid=true'"
                    :format="{ label: 'label', value: 'value' }"  />
                </div>

                <div class="col-12 lg:col-6 field">
                  <label for="idRegistryFiscalPosition">{{ $t('ExciseFiscalRegister.fiscalPosition') }}</label>
                  <GenericCustomAutocompleteV2
                    class="w-full"
                    :name="idRegistryFiscalPosition"
                    v-model="this.calculatorFilters.idRegistryFiscalPosition" 
                    :api="'masterdata/fiscal-position-combo'"
                    :format="{ label: 'label', value: 'value' }"  />
                </div>

                <div class="col-12 lg:col-6 field">
                  <label for="idRegistryFiscalUse">{{ $t('ExciseFiscalRegister.fiscalUse') }}</label>
                  <GenericCustomAutocompleteV2
                    class="w-full"
                    :name="idRegistryFiscalUse"
                    v-model="this.calculatorFilters.idRegistryFiscalUse" 
                    :api="'masterdata/fiscal-use-combo'"
                    :format="{ label: 'label', value: 'value' }"  />
                </div>

                <div class="col-12 lg:col-6 field">
                  <label for="idRegistryFiscalDestination">{{ $t('ExciseFiscalRegister.fiscalDestination') }}</label>
                  <GenericCustomAutocompleteV2
                    class="w-full"
                    :name="idRegistryFiscalDestination"
                    v-model="this.calculatorFilters.idRegistryFiscalDestination" 
                    :api="'masterdata/fiscal-destination-combo'"
                    :format="{ label: 'label', value: 'value' }"  />
                </div>

                <div class="col-12 lg:col-6 field">
                  <label for="movedQuantity">{{ $t('ExciseFiscalRegister.fiscalMovedWeight') }}</label>
                  <InputNumber
                    class="w-full" 
                    mode="decimal" :maxFractionDigits="0"
                    v-model="this.calculatorFilters.movedQuantity" />
                </div>

                <div class="col-12 lg:col-6 field">
                  <label for="movedVolume">{{ $t('ExciseFiscalRegister.fiscalMovedVolume') }}</label>
                  <InputNumber
                    class="w-full" 
                    mode="decimal" :maxFractionDigits="0"
                    v-model="this.calculatorFilters.movedVolume" />
                </div>
              </div>
            </template>

            <template #footer>
              <Button :label="$t('btn.calculate')" icon="pi pi-percentage" @click="ExciseCalculator" />
              <Button :label="$t('btn.reset')" icon="pi pi-trash" class="mx-2 p-button-outlined" @click="ResetCalculator" />
            </template>
          </Card>

          <Card class="col-8">
            <template #content>
              <div class="grid formgrid">
                <div class="col-12 lg:col-4 field">
                  <label for="exciseRate">{{ $t('ExciseFiscalRegister.exciseRate') }}</label>
                  <InputNumber
                    class="w-full" 
                    mode="decimal" :maxFractionDigits="8"
                    v-model="this.exciseCalculatorResult.exciseRate" />
                </div>

                <div class="col-12 lg:col-4 field">
                  <label for="exciseDelta">{{ $t('ExciseFiscalRegister.exciseDelta') }}</label>
                  <InputNumber
                    class="w-full" 
                    mode="decimal" :maxFractionDigits="3"
                    v-model="this.exciseCalculatorResult.exciseDelta" />
                </div>

                <div class="col-12 lg:col-4 field">
                  <label for="exciseDuty">{{ $t('ExciseFiscalRegister.exciseDuty') }}</label>
                  <InputNumber
                    class="w-full" 
                    mode="decimal" :maxFractionDigits="2"
                    v-model="this.exciseCalculatorResult.exciseDuty" />
                </div>

                <div class="col-12 lg:col-4 field">
                  <label for="exciseDutySuspended">{{ $t('ExciseFiscalRegister.exciseDutySuspended') }}</label>
                  <InputNumber
                    class="w-full" 
                    mode="decimal" :maxFractionDigits="2"
                    v-model="this.exciseCalculatorResult.exciseDutySuspended" />
                </div>

                <div class="col-12 lg:col-4 field">
                  <label for="exciseDue">{{ $t('ExciseFiscalRegister.exciseDue') }}</label>
                  <InputNumber
                    class="w-full" 
                    mode="decimal" :maxFractionDigits="2"
                    v-model="this.exciseCalculatorResult.exciseDue" />
                </div>

                <div class="col-12 lg:col-4 field">
                  <label for="localExciseDue">{{ $t('ExciseFiscalRegister.localExciseDue') }}</label>
                  <InputNumber
                    class="w-full" 
                    mode="decimal" :maxFractionDigits="2"
                    v-model="this.exciseCalculatorResult.localExciseDue" />
                </div>

                <div class="col-12 lg:col-4 field">
                  <label for="taxableQuantity">{{ $t('ExciseFiscalRegister.taxableQuantity') }}</label>
                  <InputNumber
                    class="w-full" 
                    mode="decimal" :maxFractionDigits="3"
                    v-model="this.exciseCalculatorResult.taxableQuantity" />
                </div>

                <div class="col-12 lg:col-4 field">
                  <label for="documentType">{{ $t('ExciseFiscalRegister.documentType') }}</label>
                  <InputText
                    class="w-full" v-model="this.exciseCalculatorResult.documentType" />
                </div>

                <div class="col-12 lg:col-4 field">
                  <label for="documentTypeLanguage">{{ $t('ExciseFiscalRegister.documentTypeLanguage') }}</label>
                  <InputText
                    class="w-full" v-model="this.exciseCalculatorResult.documentTypeLanguage" />
                </div>
              </div>
            </template>
          </Card>
        </div>
      </Dialog>

      <Dialog v-model:visible="showExportCalculatorDialog" modal :style="{width: '82vw'}">
        <div class="grid">
          <Card class="col-4">
            <template #content>
              <div class="grid formgrid">

                <div class="col-12 lg:col-6 field">
                  <label for="notificationCode">{{ $t('ExciseFiscalRegister.notificationCode') }}</label>
                  <InputText
                    class="w-full" v-model="this.exportCalculatorFilters.notificationCode" disabled />
                </div>

                <div class="col-12 lg:col-6 field">
                  <label for="notificationDate">{{ $t('ExciseFiscalRegister.notificationDate') }}</label>
                  <Calendar
                    class="p-inputtext-sm w-full"
                    placeholder="__/__/____"
                    disabled
                    v-model="this.exportCalculatorFilters.notificationDate"
                    name="fiscalDate" dateFormat="dd/mm/yy" :showTime="true"
                    :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
                </div>

                <!--<div class="col-12 lg:col-6 field">
                  <label for="notificationCode">{{ $t('ExciseFiscalRegister.notificationCode') }}</label>
                  <InputText class="w-full" v-model="this.calculatorFilters.notificationCode"/>
                </div>-->

                <div class="col-12 lg:col-6 field">
                  <label for="idRegistryOperationType">{{ $t('ExciseFiscalRegister.operationTypeDescription') }}</label>
                  <GenericCustomAutocompleteV2
                    class="w-full"
                    :name="idRegistryOperationType"
                    v-model="this.exportCalculatorFilters.idRegistryOperationType" 
                    :api="'masterdata/operation-type-combo'"
                    :format="{ label: 'label', value: 'value' }"  />
                </div>

                <div class="col-12 lg:col-6 field">
                  <label for="idRegistryProduct">{{ $t('ExciseFiscalRegister.idRegistryProduct') }}</label>
                  <GenericCustomAutocompleteV2
                    class="w-full"
                    :name="idRegistryProduct"
                    v-model="this.exportCalculatorFilters.idRegistryProduct" 
                    :api="'masterdata/product-combo'"
                    :format="{ label: 'label', value: 'value' }"  />
                </div>
                
                <div class="col-12 lg:col-6 field" v-if="this.exportCalculatorFilters.idFiscalNotificationHeader == null">
                  <label for="nc">{{ $t('ExciseFiscalRegister.nc') }}</label>
                  <!--<InputText class="w-full" v-model="this.calculatorFilters.nc" />-->
                  <GenericCustomAutocompleteV2
                    class="w-full"
                    :name="nc"
                    v-model="this.exportCalculatorFilters.nc" 
                    :api="'masterdata/energy-product-detail-combonc?idProduct=' + this.exportCalculatorFilters.idRegistryProduct + '&transportType=' + this.transportType + '&getOnlyValid=true'"
                    :format="{ label: 'label', value: 'valueString' }"  />
                </div>
                <div class="col-12 lg:col-6 field" v-else>
                  <label for="nc">{{ $t('ExciseFiscalRegister.nc') }}</label>
                  <!--<InputText class="w-full" v-model="this.calculatorFilters.nc" />-->
                  <GenericCustomAutocompleteV2
                    class="w-full"
                    :name="idEneryProductDetail"
                    v-model="this.exportCalculatorFilters.idEneryProductDetail" 
                    :api="'masterdata/energy-product-detail-combonc?idProduct=' + this.exportCalculatorFilters.idRegistryProduct + '&transportType=' + this.transportType + '&getOnlyValid=true'"
                    :format="{ label: 'label', value: 'value' }"  />
                </div>

                <div class="col-12 lg:col-6 field">
                  <label for="idRegistryFiscalPosition">{{ $t('ExciseFiscalRegister.fiscalPosition') }}</label>
                  <GenericCustomAutocompleteV2
                    class="w-full"
                    :name="idRegistryFiscalPosition"
                    v-model="this.exportCalculatorFilters.idRegistryFiscalPosition" 
                    :api="'masterdata/fiscal-position-combo'"
                    :format="{ label: 'label', value: 'value' }"  />
                </div>

                <div class="col-12 lg:col-6 field">
                  <label for="idRegistryFiscalUse">{{ $t('ExciseFiscalRegister.fiscalUse') }}</label>
                  <GenericCustomAutocompleteV2
                    class="w-full"
                    :name="idRegistryFiscalUse"
                    v-model="this.exportCalculatorFilters.idRegistryFiscalUse" 
                    :api="'masterdata/fiscal-use-combo'"
                    :format="{ label: 'label', value: 'value' }"  />
                </div>

                <div class="col-12 lg:col-6 field">
                  <label for="idRegistryFiscalDestination">{{ $t('ExciseFiscalRegister.fiscalDestination') }}</label>
                  <GenericCustomAutocompleteV2
                    class="w-full"
                    :name="idRegistryFiscalDestination"
                    v-model="this.exportCalculatorFilters.idRegistryFiscalDestination" 
                    :api="'masterdata/fiscal-destination-combo'"
                    :format="{ label: 'label', value: 'value' }"  />
                </div>

                <div class="col-12 lg:col-6 field">
                  <label for="movedQuantity">{{ $t('ExciseFiscalRegister.fiscalMovedWeight') }}</label>
                  <InputNumber
                    class="w-full" 
                    mode="decimal" :maxFractionDigits="0"
                    v-model="this.exportCalculatorFilters.fiscalMovedWeight" />
                </div>

                <div class="col-12 lg:col-6 field">
                  <label for="movedVolume">{{ $t('ExciseFiscalRegister.fiscalMovedVolume') }}</label>
                  <InputNumber
                    class="w-full" 
                    mode="decimal" :maxFractionDigits="0"
                    v-model="this.exportCalculatorFilters.fiscalMovedVolume" />
                </div>
              </div>
            </template>

            <template #footer>
              <Button :label="$t('btn.calculate')" icon="pi pi-percentage" @click="ExciseCalculatorItem" />
              <Button :label="$t('btn.save')" icon="pi pi-save" class="mx-4 p-button-outlined" @click="onCalculatorSave" />
            </template>
          </Card>

          <Card class="col-8">
            <template #content>
              <div class="grid formgrid">
                <div class="col-12 lg:col-4 field">
                  <label for="exciseRate">{{ $t('ExciseFiscalRegister.exciseRate') }}</label>
                  <InputNumber
                    class="w-full" 
                    mode="decimal" :maxFractionDigits="8"
                    v-model="this.exportCalculatorFilters.exciseRate" />
                </div>

                <div class="col-12 lg:col-4 field">
                  <label for="exciseDelta">{{ $t('ExciseFiscalRegister.exciseDelta') }}</label>
                  <InputNumber
                    class="w-full" 
                    mode="decimal" :maxFractionDigits="3"
                    v-model="this.exportCalculatorFilters.exciseDelta" />
                </div>

                <div class="col-12 lg:col-4 field">
                  <label for="exciseDuty">{{ $t('ExciseFiscalRegister.exciseDuty') }}</label>
                  <InputNumber
                    class="w-full" 
                    mode="decimal" :maxFractionDigits="2"
                    v-model="this.exportCalculatorFilters.exciseDuty" />
                </div>

                <div class="col-12 lg:col-4 field">
                  <label for="exciseDutySuspended">{{ $t('ExciseFiscalRegister.exciseDutySuspended') }}</label>
                  <InputNumber
                    class="w-full" 
                    mode="decimal" :maxFractionDigits="2"
                    v-model="this.exportCalculatorFilters.exciseDutySuspended" />
                </div>

                <div class="col-12 lg:col-4 field">
                  <label for="exciseDue">{{ $t('ExciseFiscalRegister.exciseDue') }}</label>
                  <InputNumber
                    class="w-full" 
                    mode="decimal" :maxFractionDigits="2"
                    v-model="this.exportCalculatorFilters.exciseDue" />
                </div>

                <div class="col-12 lg:col-4 field">
                  <label for="localExciseDue">{{ $t('ExciseFiscalRegister.localExciseDue') }}</label>
                  <InputNumber
                    class="w-full" 
                    mode="decimal" :maxFractionDigits="2"
                    v-model="this.exportCalculatorFilters.localExciseDue" />
                </div>

                <div class="col-12 lg:col-4 field">
                  <label for="taxableQuantity">{{ $t('ExciseFiscalRegister.taxableQuantity') }}</label>
                  <InputNumber
                    class="w-full" 
                    mode="decimal" :maxFractionDigits="3"
                    v-model="this.exportCalculatorFilters.taxableQuantity" />
                </div>

                <div class="col-12 lg:col-4 field">
                  <label for="documentType">{{ $t('ExciseFiscalRegister.documentType') }}</label>
                  <InputText
                    class="w-full" v-model="this.exportCalculatorFilters.documentType" />
                </div>

                <div class="col-12 lg:col-4 field">
                  <label for="documentTypeLanguage">{{ $t('ExciseFiscalRegister.documentTypeLanguage') }}</label>
                  <InputText
                    class="w-full" v-model="this.exportCalculatorFilters.documentTypeLanguage" />
                </div>
              </div>
            </template>
          </Card>
        </div>
      </Dialog>

      <div class="grid" style="margin-left: 0.2%">
          <div class="col-4 lg:col-2">
              <label for="notificationDate">{{$t('ExciseFiscalRegister.notificationDateFrom')}}</label>
              <Calendar
              class="p-inputtext-sm w-full"
              placeholder="__/__/____"
              v-model="this.filters.notificationDate"
              name="notificationDate" dateFormat="dd/mm/yy" :showTime="false"
              :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
          </div>

          <div class="col-4 lg:col-2">
              <label for="notificationDate">{{$t('ExciseFiscalRegister.notificationDateTo')}}</label>
              <Calendar
              class="p-inputtext-sm w-full"
              placeholder="__/__/____"
              v-model="this.filters.notificationDateTo"
              name="notificationDate" dateFormat="dd/mm/yy" :showTime="false"
              :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
          </div>
          
          <div class="col-4 lg:col-4 mt-2">
              <ResponsiveButton type="button" icon="pi pi-replay" class="p-button-sm mx-2 my-3" :label="$t('btn.load')" severity="secondary" @click="loadExciseFiscalRegister" /> 
              <ResponsiveButton type="button" icon="pi pi-percentage" class="p-button-success p-button-sm mx-2 my-3" :label="$t('ExciseFiscalRegister.calculator')" @click="openCalculatorDialog" />               
          </div>         
      </div>

      <div class="col-12">
          <GenericDataTable :configuration="configuration" :category="'excise-fiscal-register'" :name="'excise-fiscal-register'" 
            ref="exciseFiscalRegister" :onDialogEditSave="onRowEdit" @on-export-to-calculator="onExportToCalculator"/>
      </div>
    </main>
</template>